import * as t from './actionTypes';

const initialState = {
    logbookitems: [],
}

export default function (state = initialState, action) {
    switch (action.type) {
        case t.LOAD_LOGBOOK:
            return Object.assign({}, state, {
                logbookitems: action.payload
            });
        default:
            return state
    }
}